/*
 * -----------------------------------------------------------------------
 *  <copyright file="row-order/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import SelectWithCategories from '@components/core/select-with-categories';
import { useTranslation } from '@hooks/index';
import { OverviewRowOrderConfigurationEnumType } from '@types/graphql-global-types';

import './styles.scss';

const RowOrder = ({
    selectedValue,
    onSelect,
}: {
    selectedValue: OverviewRowOrderConfigurationEnumType | undefined;
    onSelect: (e: { target: { value: string } }) => void;
}) => {
    const { t } = useTranslation();
    const orderValues = [
        {
            id: OverviewRowOrderConfigurationEnumType.SITE_NAME_ASC,
            text: t('admin:siteNameAsc'),
        },
        {
            id: OverviewRowOrderConfigurationEnumType.SITE_NAME_DESC,
            text: t('admin:siteNameDesc'),
        },
        {
            id: OverviewRowOrderConfigurationEnumType.SITE_SCORE_DESC,
            text: t('admin:siteScoreDesc'),
        },
        {
            id: OverviewRowOrderConfigurationEnumType.RED_KR_IS_DESC,
            text: t('admin:redKRIsDesc'),
        },
        {
            id: OverviewRowOrderConfigurationEnumType.RED_DECISION_KR_IS_DESC,
            text: t('admin:redDecisionKRIsDesc'),
        },
    ];

    return (
        <div className="row-order-panel">
            <strong>{t('admin:rowOrder')}</strong>
            <SelectWithCategories
                onChange={() => onSelect}
                fieldSelect="rowOrder"
                dataArray={orderValues}
                showWarning={false}
                filterable={false}
                currentState={selectedValue}
                customId="row-order-site--select"
                customClassName="row-select"
            />
        </div>
    );
};

export default RowOrder;
